import * as grid from 'view/styles/grid';

export const SPINNER_SIZE = grid.multiple(6);
